export * from './LifestylesListItemLightboxTitle.types';
export { default as LifestylesListItemLightboxTitle } from './LifestylesListItemLightboxTitle';
